import {AQL_CONSTANTS} from '../../../constants/aql.constants';
import AttributesModel from '../AttributesModel';
import Model from '../Model';

export default class UserFriendlyQueryModel extends Model {

	constructor(data) {
		super(data);

		this.repositories = data.repositories || [];
		this.included_artifacts_patterns = data.included_artifacts_patterns || [];
		this.excluded_artifacts_patterns = data.excluded_artifacts_patterns || [];

		if (data.builds && data.builds.length) {
			this.builds = data.builds.map(build => {
				return new AttributesModel({
					name: build.name || build.name,
					values: build.values || build.number
				});
			});
		} else {
			this.builds = [];
		}

		if (data.search_properties && data.search_properties.length) {
			this.search_properties = data.search_properties.map(prop => {
				return new AttributesModel({
					name: prop.name || prop.key,
					values: prop.values || prop.value
				});
			});
		} else {
			this.search_properties = [];
		}

		this.search_properties_logical_operator = data.search_properties_logical_operator || AQL_CONSTANTS.LOGICAL_OPERATORS.OR;
		this.included_logical_operator = data.included_logical_operator || AQL_CONSTANTS.LOGICAL_OPERATORS.OR;
	}

	build() {
		let userFriendlyQueryJson = {
			repositories: this.repositories,
			search_properties_logical_operator: this.search_properties_logical_operator,
			included_logical_operator: this.included_logical_operator,
			included_artifacts_patterns: this.included_artifacts_patterns,
			excluded_artifacts_patterns: this.excluded_artifacts_patterns
		};

		if (this.builds && this.builds.length) {
			userFriendlyQueryJson.builds = this.builds.map(item => {
				return item.build('name', 'number', true);
			});
		}

		if (this.search_properties && this.search_properties.length) {
			userFriendlyQueryJson.search_properties = this.search_properties.map(item => {
				return item.build('key', 'value', true);
			});
		}
		return userFriendlyQueryJson;
	}

	_getSearchCriteriaItems(items, comparator, property) {
		return items.map((item) => {
			return {
				[property]: {
					[comparator]: item
				},
			};
		});
	}

	buildAql() {
		let searchCriterias = [];
		searchCriterias.push({
			items: this._getSearchCriteriaItems(this.repositories, AQL_CONSTANTS.COMPARATORS.EQUALS, 'repo'),
			operator: AQL_CONSTANTS.LOGICAL_OPERATORS.OR
		});
		searchCriterias.push({
			items: this.builds.map((build) => {
				return {
					[AQL_CONSTANTS.LOGICAL_OPERATORS.AND]: [{
						[AQL_CONSTANTS.PROPERTIES.ARTIFACT_BUILD_NAME]: {
							[AQL_CONSTANTS.COMPARATORS.EQUALS]: build.name
						}
					}, {
						[AQL_CONSTANTS.PROPERTIES.ARTIFACT_BUILD_NUMBER]: {
							[AQL_CONSTANTS.COMPARATORS.EQUALS]: build.values
						}
					}]
				};
			}),
			operator: AQL_CONSTANTS.LOGICAL_OPERATORS.OR
		});
		searchCriterias.push({
			items: this.search_properties.map((prop) => {
				return {
					[`@${prop.name}`]: prop.values
				};
			}),
			operator: this.search_properties_logical_operator
		});
		searchCriterias.push({
			items: this._getSearchCriteriaItems(this.included_artifacts_patterns, AQL_CONSTANTS.COMPARATORS.MATCH, 'name'),
			operator: this.included_logical_operator
		});
		searchCriterias.push({
			items: this._getSearchCriteriaItems(this.excluded_artifacts_patterns, AQL_CONSTANTS.COMPARATORS.NOT_MATCH, 'name'),
			operator: AQL_CONSTANTS.LOGICAL_OPERATORS.AND
		});
		let queryPredicate = searchCriterias
			.filter(criteria => criteria.items.length)
			.map(criteria => {
				return {
					[criteria.operator]: criteria.items
				};
			});

		if (queryPredicate.length) {
			let userFriendlyQuery = {
				[AQL_CONSTANTS.LOGICAL_OPERATORS.AND]: queryPredicate
			};
			return `items.find(${
					JSON.stringify(userFriendlyQuery)
				}).include(${
					JSON.stringify(AQL_CONSTANTS.INCLUSION_PROPERTIES)
					    .replace('[','')
					    .replace(']','')
				})`;
		} else {
			return '';
		}
	}


	toUserFirendlyQuerySrting() {
		let res = [];
		let repos = this.repositories.join(', ');
		let builds = this.builds.map(build => `${build.name} ${build.values}`).join(', ');
		let props = this.search_properties.map(prop => `${prop.name} = ${prop.values}`).join(', ');
		let included = this.included_artifacts_patterns.join(', ');
		let excluded = this.excluded_artifacts_patterns.join(', ');
		if(repos && repos.length) {
			res.push(`Repositories: ${repos}`)
		}
		if(builds && builds.length) {
			res.push(`Builds: ${builds}`);
		}
		if(props && props.length) {
			res.push(`Properties: ${props}`)
		}
		if(included && included.length) {
			res.push(`Including: ${included}`)
		}
		if(excluded && excluded.length) {
			res.push(`Excluding: ${excluded}`)
		}
		return res.join(' | ');
	}
}


// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/UserFriendlyQueryModel.js